import {Component, effect, inject, input, ResourceStatus} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {InputComponent} from '../../common/form/input/input.component';
import {NgIf} from '@angular/common';
import {LeadResources} from '../../../../resources/lead.resources';
import {SubscriptionContextV2Service} from '../../../../services/subscription-v2-context.service';
import {createOrUpdateLead} from '../../../../common/lead';
import {FIREBASE_AUTH} from '../../../config/module.di.tokens';
import {SocialTrackService} from '../../../../services/social-track.service';
import {Router} from '@angular/router';
import {SessionResources} from '../../../../resources/session.resources';
import {SexButtonComponent} from '../../common/button/sex-button/sex-button.component';
import {DynamicScriptDirective} from '../../../../common/directive/dynamic-script.directive';
import {LeadService} from '../../../../services/lead.service';

@Component({
  selector: 'app-sub-v2-who',
  imports: [
    ReactiveFormsModule,
    InputComponent,
    NgIf,
    SexButtonComponent,
    DynamicScriptDirective
  ],
  templateUrl: './sub-v2-who.component.html',
})
export class SubV2WhoComponent {

  sessionId = input<string>()
  referralCode = input<string>()
  sessionResource = inject(SessionResources)
  socialTrackService = inject(SocialTrackService)
  subscriptionContextV2Service = inject(SubscriptionContextV2Service)
  leadResources = inject(LeadResources)
  leadService = inject(LeadService)
  formBuilder = inject(FormBuilder)
  auth = inject(FIREBASE_AUTH)
  router = inject(Router)
  showBadEmail = false
  whoForm = new FormGroup({
    email: new FormControl<string>(null, Validators.compose([Validators.required, Validators.email])),
  })

  constructor() {
    effect(() => {
      const currentLeadStatus = this.leadResources.currentLead.status()
      if(currentLeadStatus == ResourceStatus.Resolved) {
        const currentLead = this.leadResources.currentLead.value()
        if(currentLead && !this.whoForm.controls.email.value) {
          this.whoForm.controls.email.setValue(currentLead.email)
        }
      }
    });
    effect(async () => {
      const lead = this.leadResources.currentLead.value()
      if(this.referralCode() && lead) {
        await this.leadService.clearLeads()
        this.leadResources.currentLead.reload()
        this.whoForm.controls.email.setValue(null)
      }
    })
  }

  async selectSexOrTopicOption(sex: string) {

    if(this.whoForm.valid) {
      const currentLead = await createOrUpdateLead(this.sessionId(), this.leadResources, this.auth)
      const topic = this.sessionResource.session.value()?.topic
      if(topic == "lgbt_w") {
        currentLead.topicOption = sex as 'FF'|'FB'|'FX'
        sex = "F"
      }
      currentLead.sex = sex
      currentLead.email = this.whoForm.controls.email.value

      this.subscriptionContextV2Service.sex.set(sex)
      this.leadResources.saveLeadRequest.set(currentLead)

      this.socialTrackService.trackGAEvent('who_select_sex')
      this.socialTrackService.trackGAEvent('who_next')

      await this.router.navigate(['/subscribe-v2', this.sessionId(), 'search'], {
        queryParams: {
          referralCode: this.referralCode()
        }
      })
    } else {
      this.whoForm.controls.email.markAsTouched();
      this.showBadEmail = true
    }
  }

}
